<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">
        비즈니스 스킬<br />
        <span class="container_content_list_title_span"
          >대면 / 비대면(실시간 화상)</span
        >
      </div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication46.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#현업 표현</div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              비즈니스 회화 정규 과정
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            다양한 비즈니스 상황에서 발생되는 용어와 표현을 습득하고 효과적인
            커뮤니케이션을 학습하는 과정입니다.
          </div>
          <div class="container_content_text_content">
            성공적인 글로벌 비즈니스 수행을 위한 실무 외국어 능력 향상 및 Global
            Communication Skill 향상으로 비즈니스 성과에 기여<br />
            현업에서 벌어지는 상황별 소통 시뮬레이션 진행 및 현지 이문화 이해<br />
            레벨 테스트를 통한 체계적인 클래스 배정, 사전-사후 동영상 플립러닝을
            통한 체계적 학습 제공
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication7.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#실전 훈련</div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              글로벌 비즈니스 스킬 워크숍
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            글로벌 비즈니스 환경에서 효과적인 업무 스킬 훈련으로 글로벌 업무
            경쟁력을 강화합니다.
          </div>
          <div class="container_content_text_content">
            성공적인 Business Skill을 위한 효과적인 delivery skill, 슬라이드 및
            이메일 작성법, 업무 상활별 프로세스와 적절한 표현 및 매너 학습<br />
            상황별 Case simulation을 통한 실전 감각 향상, 3일 24시간 Workshop 전
            후 마이크로러닝 콘텐츠와 사전 학습 준비로 &lt;완전학습&gt;추구<br />
            <span class="text-content2">프레젠테이션</span
            ><span class="text-content2">협상</span
            ><span class="text-content2">문서작성</span
            ><span class="text-content2">미팅</span
            ><span class="text-content2">컨퍼런스 콜</span>
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication8.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#단시간 핵심</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              글로벌 비즈니스 스킬 특강
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            주요한 비즈니스 스킬 중 필요한 영역만 뽑아 핵심 요소를 중점적으로
            전달, 학습하는 특강입니다.
          </div>
          <div class="container_content_text_content">
            2~4시간 단위의 비즈니스 스킬 모듈을 바탕으로 분야별 전문 강사진
            투입<br />
            글로벌 마인드셋, Socializing 커뮤니케이션 스킬, 오피스 커뮤니케이션
            등 50여가지의 주제 보유<br />
            대상과 교육 목적에 따라 맞춤형 교육 진행 가능
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: { Contact },
  name: "Skill",
};
</script>

<style></style>
